const wallet = {
  'wallet.tips.error1': 'User denied authorization',
  'wallet.tips.error2': '{{msg}}. Please switch within 10s',
  'wallet.logout.title': 'Logout Success',
  'wallet.login.title': 'Login Success',
  'wallet.login.modal.tips': 'New to Ethereum?',
  'wallet.login.modal.learn': 'Learn more about wallets',
  'wallet.login.btns': 'Connect Wallet',
  'wallet.login.logout.tips': 'Logout',
  'wallet.login.modal.title': 'Connect to a wallet',
  'wallet.login.details': 'Details',
  'wallet.profile.title': 'DAO Governance',
}

export default wallet
